import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  h1 {
    text-align: center;
    color: var(--clr-red-dark);
  }
`;

export default Wrapper;
